import { IOrderItem } from '@/api';

import { createEvent } from './createEvent';

export const reloadOfflineCartEvent = createEvent<Partial<IOrderItem>>('RELOAD_OFFLINE_CART');
